import { Component, Inject, LOCALE_ID, OnInit } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { map, catchError, tap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { NwbAlertService } from '@wizishop/ng-wizi-bulma';
import { createAlertConfig } from 'src/app/shared/factoryconfigAlert';
import { Router } from '@angular/router';

@Component({
    selector: 'mygroup',
    templateUrl: './mygroup.component.html',
    styleUrls: ['./mygroup.component.css']
})
/** mygroup component*/
export class MygroupComponent implements OnInit {
    
  resultsLength = 0;
  isLoadingResults = false;
  isRateLimitReached = false;

  soci: any[] = [];
  amiciFedeli: any[] = [];

  socio$: Observable<any>;

  constructor(@Inject(LOCALE_ID) public locale: string, private dataService: DataService, 
    private alertservice: NwbAlertService, private router: Router) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  private getDatiGruppo(): void {
    
    this.isLoadingResults = true;
    this.dataService.gruppo
      .pipe(
        map(data => {
          // Flip flag to show that loading has finished.
          this.isLoadingResults = false;
          this.isRateLimitReached = false;
          this.resultsLength = data.length;
          return data;
        }),
        catchError(() => {
          this.isLoadingResults = false;
          // Catch if the GitHub API has reached its rate limit. Return empty data.
          this.isRateLimitReached = true;
          return of([]);
        })
    ).subscribe(data => {
        this.soci = data.soci;
        this.amiciFedeli = data.amiciFedeli;
      });
  }

  ngOnInit(): void {
    this.socio$ = this.dataService.getData().pipe(tap((socio) => {
      if (!socio.idGestore) {
        this.getDatiGruppo();
      }
    }));
  }

  rimuovi(socio: any) {
    this.dataService.deleteAssociazioneGruppo(socio.id, socio.tipo).subscribe(() => {
      if (socio.tipo == 1) {
        this.alertservice.open(createAlertConfig("Socio rimosso", true)).afterClosed().subscribe();
      } else {
        this.alertservice.open(createAlertConfig("Amico fedele rimosso", true)).afterClosed().subscribe();
      }
      this.getDatiGruppo();
    }, (error) => {
      if(error.error) {

        this.alertservice.open(createAlertConfig(error.error, false)).afterClosed().subscribe();
        return;
      }

      if (this.locale == 'it') {
        this.alertservice.open(createAlertConfig("Errore non gestito. Provare a ricaricare la pagina. Se persiste contattare l'assistenza", false)).afterClosed().subscribe();
      } else {
        this.alertservice.open(createAlertConfig("Error not manage. Try to reload the current page. If persist contact the support", false)).afterClosed().subscribe();
      }
    });
  }
}
